import { render } from "./hint.vue?vue&type=template&id=3ecd3b10&scoped=true"
import script from "./hint.vue?vue&type=script&lang=js"
export * from "./hint.vue?vue&type=script&lang=js"

import "./hint.vue?vue&type=style&index=0&id=3ecd3b10&scoped=true&lang=css"

import exportComponent from "D:\\project\\97job-wechat\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ecd3b10"]])

export default __exports__